import { render, staticRenderFns } from "./kpis-charts.vue?vue&type=template&id=3e838787&scoped=true"
import script from "./kpis-charts.vue?vue&type=script&lang=js"
export * from "./kpis-charts.vue?vue&type=script&lang=js"
import style0 from "./kpis-charts.vue?vue&type=style&index=0&id=3e838787&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e838787",
  null
  
)

export default component.exports